(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  const gallery = document.querySelector('.mw-image-gallery');
  const images = document.querySelectorAll('.mw-image-gallery a');
  const modal = document.querySelector('.mw-modal');
  if (!gallery || !modal || images.length === 0) return;

  const modalImage = modal.querySelector('img');
  let currentIndex = 0;

  // ---------------------------------------------------------
  // 1) Modal behavior
  // ---------------------------------------------------------
  function showModal(index) {
    if(window.innerWidth > 749){
      modalImage.src = images[index].dataset.desktop;
    } else {
      modalImage.src = images[index].dataset.mobile;  
    }
    modal.classList.add('show');
    currentIndex = index;
  }

  function hideModal() {
    modal.classList.remove('show');
  }

  function showPrevImage(e) {
    e.preventDefault();
    e.stopPropagation();
    showModal(currentIndex === 0 ? images.length - 1 : currentIndex - 1);
  }

  function showNextImage(e) {
    e.preventDefault();
    e.stopPropagation();
    showModal(currentIndex === images.length - 1 ? 0 : currentIndex + 1);
  }

  const prevArrow = modal.querySelector('.mw-modal-prev');
  const nextArrow = modal.querySelector('.mw-modal-next');
  prevArrow.addEventListener('click', showPrevImage);
  nextArrow.addEventListener('click', showNextImage);
  modal.addEventListener('click', hideModal);

  // ---------------------------------------------------------
  // 2) Prevent native drag (stops "drag image" cursor)
  // ---------------------------------------------------------
  images.forEach((a) => {
    a.addEventListener('dragstart', (e) => e.preventDefault());
  });

  // ---------------------------------------------------------
  // 3) Click-vs-drag logic:
  //    - If user drags to scroll, don't open modal.
  // ---------------------------------------------------------
  let startX = 0;
  let startScrollLeft = 0;
  let isDown = false;
  let moved = false;

  // Enable "grab to scroll" on desktop
  gallery.style.cursor = 'grab';

  gallery.addEventListener('pointerdown', (e) => {
    // only left click / primary touch
    if (e.pointerType === 'mouse' && e.button !== 0) return;

    isDown = true;
    moved = false;
    startX = e.clientX;
    startScrollLeft = gallery.scrollLeft;
    gallery.setPointerCapture(e.pointerId);
    gallery.style.cursor = 'grabbing';
  });

  gallery.addEventListener('pointermove', (e) => {
    if (!isDown) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > 6) moved = true; // threshold to classify as drag
    gallery.scrollLeft = startScrollLeft - dx;
  });

  function endPointer(e){
    if (!isDown) return;
    isDown = false;
    gallery.style.cursor = 'grab';
    try { gallery.releasePointerCapture(e.pointerId); } catch(_) {}
  }

  gallery.addEventListener('pointerup', endPointer);
  gallery.addEventListener('pointercancel', endPointer);
  gallery.addEventListener('pointerleave', endPointer);

  // Open modal only on true clicks (not drags)
  images.forEach((image, index) => {
    image.addEventListener('click', (e) => {
      // If user dragged, kill the click
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      e.preventDefault();
      showModal(index);
    });
  });

})();

  } catch(e) { console.error(e); }
})();
})();
